import { useMemo } from "react";
import { encode } from "uqr";

/**
 * A QR code as an inline SVG, one path for all dark modules. Always dark on
 * white with a four-module quiet zone, whatever the theme: a scanner reads
 * contrast, and an inverted code in dark mode is one many of them refuse.
 */
export function QrCode({
  value,
  label,
  className,
}: {
  value: string;
  /** What a screen reader hears instead of the pattern. */
  label: string;
  className?: string;
}) {
  const { size, path } = useMemo(() => {
    const border = 4;
    const qr = encode(value, { ecc: "M", border });
    const commands: string[] = [];
    qr.data.forEach((row, y) => {
      row.forEach((dark, x) => {
        if (dark) commands.push(`M${x} ${y}h1v1h-1z`);
      });
    });
    return { size: qr.size, path: commands.join("") };
  }, [value]);

  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
      className={className}
      data-testid="connect-qr"
      data-value={value}
    >
      <rect width={size} height={size} className="fill-white" />
      <path d={path} className="fill-black" />
    </svg>
  );
}
